module.exports = __webpack_public_path__ + "static/media/Course summary React Fundamentals-NL.34a1a378.pdf";